import { capitalizeFirstLetterOnly } from '@/helpers/dataHelper';
import { Collapse, Empty, Pagination, Skeleton } from 'antd';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

const AssessmentTable = ({ setQuery, query }) => {
  const router = useRouter();
  const { Panel } = Collapse;

  const user = useSelector((state: any) => state.auth?.creds?.user_data?.user_type);
  const loading = useSelector(
    (state: any) => state?.allAssessmentReducer?.assessment?.getAssessmentStatus
  );
  const assessments = useSelector(
    (state: any) => state?.allAssessmentReducer?.assessment
  );

  const columns = [
    {
      title: 'S.N.',
      dataIndex: 'sn',
      key: 'sn',
    },
    {
      title: 'Assessment Name',
      dataIndex: 'name',
    },
    {
      title: 'Room Name',
      dataIndex: 'room',
    },
    {
      title: 'Course Name',
      dataIndex: 'course',
    },
    {
      title: 'Due Date',
      dataIndex: 'due',
    },
    {
      title: '',
      dataIndex: 'action',
    },
  ];

  if (user === 'client')
    columns.splice(4, 0, {
      title: 'Marks',
      dataIndex: 'marks',
    });

  const handlePagination = (page: any, pageSize: any) => {
    setQuery({ ...query, page, per_page: pageSize });
  };

  return (
    <>
      {loading === 'request' ? (
        Array.apply(null, { length: 3 })?.map((each: number, idx) => <Skeleton />)
      ) : assessments?.data?.length === 0 ? (
        <Empty
          description={
            <div className="pl-3 pt-2 text-black text-center">
              No Assessments Found.
            </div>
          }
        />
      ) : (
        <>
          <div className="d-flex justify-content-between px-2 mb-2">
            <h4 className={`m-0 ${user === 'client' && 'text-dark'}`}>Room Name</h4>
            <h4 className={`m-0 ${user === 'client' && 'text-dark'}`}>
              No. of Assessments
            </h4>
          </div>
          <Collapse
            accordion
            className="assessment-collapse"
            style={{ lineHeight: '0 !important' }}
          >
            {assessments?.data.length !== 0 &&
              assessments?.data?.map((each, index) => (
                <Panel
                  key={index}
                  header={
                    <div className="d-flex align-items-center justify-content-between ">
                      <div
                        className="d-flex gap-2 font-weight-bold"
                        style={{ fontSize: '15px' }}
                      >
                        {capitalizeFirstLetterOnly(each?.title)}
                      </div>
                      <span className="font-weight-bold">
                        {user === 'client'
                          ? each?.assesments?.length
                          : each?.assesment?.length}
                      </span>
                    </div>
                  }
                >
                  <div className="px-2">
                    <div className="d-flex justify-content-between ">
                      <h5 className="w-100 m-0">Assessments</h5>
                      <h5 className="text-center w-100 m-0">Course</h5>
                      <h5 className="text-center w-100 m-0">Due Date</h5>
                      {user === 'client' && (
                        <h5 className="text-center w-100 m-0">Marks Obtained</h5>
                      )}
                      <h5 className="text-center w-100 m-0"></h5>
                    </div>
                    {user === 'client'
                      ? each?.assesments?.length !== 0 &&
                        each?.assesments?.map((el, index) => (
                          <div
                            className={`d-flex align-items-center justify-content-between ${
                              index + 1 !== each?.assesments?.length &&
                              'border-bottom '
                            } py-3`}
                            key={index}
                          >
                            <div className="font-weight-bold w-100">
                              {capitalizeFirstLetterOnly(el?.question)}
                            </div>
                            <span className="text-center w-100">{el?.course}</span>
                            <span className="text-center w-100 ">
                              {el?.due_date !== null &&
                                moment(el?.due_date).format('Do MMMM  YYYY')}
                            </span>
                            <span className="text-center w-100">
                              {el?.answer[0]?.mark_obtained || 'Not Marked'}
                            </span>

                            <div className="w-100 d-flex justify-content-end ">
                              <button
                                className="btn btn-sm btn-secondary border-danger px-3"
                                style={{
                                  fontWeight: '500',
                                }}
                                onClick={() => {
                                  router.push({
                                    pathname: `/room/${each?.title
                                      ?.split(' ')
                                      .join('-')}/assessment/${el?.id}`,
                                  });
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        ))
                      : each?.assesment?.length !== 0 &&
                        each?.assesment?.map((el, index) => (
                          <div
                            className={`d-flex align-items-center justify-content-between ${
                              index + 1 !== each?.assesment?.length &&
                              'border-bottom '
                            } py-3`}
                            key={index}
                          >
                            <div className="font-weight-bold w-100">
                              {capitalizeFirstLetterOnly(el?.title)}
                            </div>
                            <span className="text-center w-100">
                              {user === 'client' ? '' : el?.subject__course__name}
                            </span>
                            <span className="text-center w-100 ">
                              {el?.due_date !== null &&
                                moment(el?.due_date).format('Do MMMM  YYYY, h:mm a')}
                            </span>
                            <div className="w-100 d-flex justify-content-end ">
                              <button
                                className="btn btn-sm btn-secondary border-danger px-3"
                                style={{
                                  fontWeight: '500',
                                }}
                                onClick={() => {
                                  router.push({
                                    pathname: `/room/${each?.slug}/assessment/${el?.id}/dashboard`,
                                    query: {
                                      tab: 'question',
                                    },
                                  });
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        ))}
                  </div>
                </Panel>
              ))}
          </Collapse>
        </>
      )}
      <div className="pagination-position mt-2">
        {loading === 'request' ? (
          <Skeleton.Button className="mt-5 float-right" active />
        ) : (
          <Pagination
            defaultCurrent={query?.page}
            total={
              // task?.meta?.total
              10
            }
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            showSizeChanger
            defaultPageSize={query?.per_page}
            onChange={handlePagination}
            className="mt-5 float-right"
          />
        )}
      </div>
    </>
  );
};

export default AssessmentTable;
